import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import paths from '../../../_helpers/paths';
import { reportsPageModule, loadFincenterActs, exportFincenterAct, generateFincenterAct } from '../ReportsPageDucks';
import { Box, Typography, Select, MenuItem, Popover, IconButton } from '@material-ui/core';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { reportsFincenterActsColumn } from './ReportsFincenterActsColumn';
import { useHistory } from 'react-router-dom';
import Button from '../../../_ui/Button/Button';
import moment from 'moment';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const ReportsFincenterActsPage = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const reportFincenterActs = useSelector(state => state[reportsPageModule].reportFincenterActs);
  const loadingFincenterActs = useSelector(state => state[reportsPageModule].loadingFincenterActs);

  const [currentYear, setCurrentYear] = useState(String(new Date().getFullYear()));
  const [years, setYears] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const currentYearNum = new Date().getFullYear();
    const yearsList = [];
    for (let i = currentYearNum - 5; i <= currentYearNum + 5; i++) {
      yearsList.push(i);
    }
    setYears(yearsList);
    setCurrentYear(String(currentYearNum));
  }, []);

  useEffect(() => {
    dispatch(loadFincenterActs(currentYear));
  }, [currentYear, dispatch]);

  const handleYearChange = (event) => {
    const year = event.target.value;
    setCurrentYear(year);
  }

  const handleDownloadAct = (documentId) => {
    dispatch(exportFincenterAct(documentId));
  };

  const handleGenerateAct = () => {
    dispatch(generateFincenterAct(history));
  };

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const canGenerateReport = useMemo(() => {
    const today = moment();
    const startDate = moment().date(16);
    const endDate = moment().endOf('month');
    const isInAllowedPeriod = today.isBetween(startDate, endDate, 'day', '[]');
    if (!isInAllowedPeriod) return false;
    const currentMonth = today.month();
    const currentYear = today.year();
    const hasCurrentMonthReport = reportFincenterActs.content.some(act => {
      if (!act.periodMonth) return false;
      const actDate = moment(act.periodMonth);
      return actDate.month() === currentMonth && actDate.year() === currentYear;
    });
    return !hasCurrentMonthReport;
  }, [reportFincenterActs]);

  const breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_reportsFincenterActsPage'), href: paths.reportsFincenterActsPage }
  ];
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <div className="flex justify-between items-center">
          <h3>{t('reportsPage_fincenterActPage')}</h3>
        </div>


        <Box className="flex justify-between items-center mt2">
          <Box className="flex items-center" style={{ gap: 8 }}>
            <Typography style={{ fontSize: '14px' }}>
              {t('reportsPage_fincenterActPeriod')}
            </Typography>

            <Select
              value={currentYear}
              onChange={handleYearChange}
              variant="outlined"
              style={{ width: '150px', height: '40px' }}
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <div className="flex items-center">
            <Button
              text={t('reportsPage_generateFincenterAct')}
              onClick={handleGenerateAct}
              loading={loadingFincenterActs}
              disabled={!canGenerateReport}
            />
            <IconButton aria-describedby={id} onClick={handleInfoClick} color="primary">
              <InfoOutlinedIcon />
            </IconButton>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleInfoClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} style={{ maxWidth: 300 }}>
                <Typography>{t('reportsPage_fincenterActInfo')}</Typography>
              </Box>
            </Popover>
          </div>

        </Box>
        <div className="mt1">
          <StaticTablePagination
            sortable={false}
            loading={loadingFincenterActs}
            columns={reportsFincenterActsColumn({ t, language: i18n.language,onDownloadAct: handleDownloadAct,history })}
            totalElements={reportFincenterActs.totalElements}
            data={reportFincenterActs.content}
          />
        </div>
      </Paper>
    </>
  );
};

export default ReportsFincenterActsPage;
